export const Scripts = {
    WISTIA: 'https://fast.wistia.com/assets/external/E-v1.js',
    DATEV_MARKETING: 'https://www.datev-mymarketing.de/onlineMedia/code.js?ids=84343',
    HUBSPOT_MEETING_BOOKER: 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js',
    FRESHCHAT_WIDGET: '//eu.fw-cdn.com/10874830/386147.js',
    TYPEFORM_SCRIPT_SRC: 'https://embed.typeform.com/next/embed.js',
} as const
